import React, { lazy, useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import MainLayout from '../layout/main-layout'
import { Protected } from './Protected'
import Loadable from './../components/Loadable'
import { NotFound } from '../features/pages/not-found'
import AssetNewPage from '../features/asset/asset-new'
import AssetBulkPage from '../features/asset/asset-bulk'
import MyAssetBulkPage from '../features/myasset/myasset-bulk'
import Subcategory from '../features/subcategory'
import AssetInfoEdit from '../features/asset/asset-edit/components/StatusReview/AssetInfoEdit'
import { connect } from 'react-redux'
import { EnumDataAction } from '../features/auth/redux/authAction'




// dashboard routing
const Dashboard = Loadable(lazy(() => import('./../features/pages/dashboard')))
const CategoryList = Loadable(lazy(() => import('../features/category')))
const VendorList = Loadable(lazy(() => import('../features/vendor')))
const AssetList = Loadable(lazy(() => import('../features/asset/asset-list')))
const ViewAssets = Loadable(
  lazy(() =>
    import('../features/asset/asset-edit/components/StatusReview/ViewAssets')
  )
)
const RolesPage = Loadable(lazy(() => import('../features/auth/RolesPage')))
const FileUpload = Loadable(
  lazy(() => import('./../features/asset/asset-form/components/FileUpload'))
)
const UploadVideoClip = Loadable(
  lazy(() => import('./../features/videoclip/components/UploadVideoClip'))
)
const ClipMetaData = Loadable(
  lazy(() => import('./../features/videoclip/components/ClipMetaData'))
)
const VideoClipList = Loadable(
  lazy(() => import('./../features/videoclip/VideoClipList'))
)

const ImageList = Loadable(
  lazy(() => import('./../features/image-library/image-list'))
)

//My Asset routings
const MyAssetList = Loadable(
  lazy(() => import('../features/myasset/myasset-list'))
)

const MyAssetPage = Loadable(
  lazy(() => import('../features/myasset/myasset-new'))
)

const MyAssetEditPage = Loadable(
  lazy(() => import('../features/myasset/myasset-edit/components/StatusDraft'))
)

const MyAssetAnalysingPage = Loadable(
  lazy(() =>
    import('../features/myasset/myasset-edit/components/StatusAnalysing')
  )
)
const MyAssetInReviewPage = Loadable(
  lazy(() =>
    import(
      '../features/myasset/myasset-edit/components/StatusReadyForReview/index'
    )
  )
)

const MyAssetInfoEdit = Loadable(
  lazy(() =>
    import(
      '../features/myasset/myasset-edit/components/StatusReadyForReview/MyAssetInfoEdit'
    )
  )
)
//Upcoming-Events routings
const EventsPage = Loadable(
  lazy(() => import('../features/upcoming-events/index'))
)
const EventForm = Loadable(
  lazy(() =>
    import('../features/upcoming-events/calender-section/event-form/index')
  )
)

//Copyright-content routings
const ContentList = Loadable(
  lazy(() => import('../features/copyright-content/content-list'))
)
const ContentCreatePage = Loadable(
  lazy(() => import('../features/copyright-content/content-create'))
)

//font-list
const FontList = Loadable(
  lazy(() => import('../features/font-library/font-list/index'))
)

const ContentEditPage = Loadable(
  lazy(() => import('../features/copyright-content/content-edit'))
)

const ImageEditPage = Loadable(
  lazy(() => import('../features/image-library/image-edit/index'))
)
//Trending-topics routings

const TrendingTopicsPage = Loadable(
  lazy(() => import('../features/trending-topics/index'))
)
//Template routings
const TemplateList = Loadable(
  lazy(() => import('../features/template/template-list/index'))
)
const TemplateNew = Loadable(
  lazy(() => import('../features/template/template-new'))
)
const TemplateNewSource = Loadable(
  lazy(() => import('../features/template/template-new/TemplateNewSource'))
)
const TemplateNewOrientation = Loadable(
  lazy(() => import('../features/template/template-new/TemplateNewOrientation'))
)
const UpcomingTemplateList = Loadable(
  lazy(() => import('../features/template/template-list/category-list'))
)

const DraftTemplatePage = Loadable(
  lazy(() => import('../features/template/template-edit/status-draft'))
)

const TemplateInstances = Loadable(
  lazy(() =>
    import('../features/template/template-list/components/TemplateInstances')
  )
)

const TemplateInstanceAdd = Loadable(
  lazy(() => import('../features/template/template-instance-new/index'))
)


const UpcomingTemplateEdit = Loadable(
  lazy(() =>
    import('../features/template/template-edit/status-processed/index')
  )
)

const TemplateInfoEdit = Loadable(
  lazy(() =>
    import(
      '../features/template/template-edit/status-processed/components/TemplateInfoEdit'
    )
  )
)

const SubCategoryList = Loadable(lazy(() => import('../features/subcategory')))
const TagsForm = Loadable(
  lazy(() => import('./../features/asset/asset-form/components/TagsForm'))
)
const PublicAssetTabs = Loadable(
  lazy(() =>
    import(
      '../features/asset/asset-edit/components/StatusReview/PublicAssetTabs'
    )
  )
)
const InReviewAssetEditPage = Loadable(
  lazy(() => import('../features/asset/asset-edit/components/LandscapeTab'))
)
const AnalysingPage = Loadable(
  lazy(() => import('../features/asset/asset-edit/components/StatusAnalysing'))
)

const AssetEditPage = Loadable(
  lazy(() =>
    import('../features/asset/asset-edit/components/StatusDraft/AssetEditPage')
  )
)

const CreateSegment = Loadable(() =>
  import('../features/asset/asset-edit/components/LandscapeTab/CreateSegment')
)

const SegmentList = Loadable(
  lazy(() =>
    import(
      '../features/asset/asset-edit/components/LandscapeTab/LandscapeSegmentList'
    )
  )
)

const EntityList = Loadable(
  lazy(() => import('../features/entity-tags/entity-tags-list'))
)

const EntityTagsNew = Loadable(
  lazy(() => import('../features/entity-tags/entity-tags-new/index'))
)

const EntityTagsEdit = Loadable(
  lazy(() => import('../features/entity-tags/entity-tags-edit/index'))
)

const IdentifierList = Loadable(
  lazy(() => import('../features/identifier/identifier-list'))
)

const IdentifierNew = Loadable(
  lazy(() => import('../features/identifier/identifier-new/index'))
)

const IdentifierEdit = Loadable(
  lazy(() => import('../features/identifier/identifier-edit'))
)

const CompositionTagsList = Loadable(
  lazy(() => import('../features/composition-tags/composition-tags-list/index'))
)

const CompositionTagsNew = Loadable(
  lazy(() => import('../features/composition-tags/composition-tags-new/index'))
)

const CompositionTagsEdit = Loadable(
  lazy(() => import('../features/composition-tags/composition-tags-edit/index'))
)
const CampaignsNew = Loadable(
  lazy(() => import('../features/campaigns/campaigns-new'))
)

const CampaignsList = Loadable(
  lazy(() => import('../features/campaigns/campaigns-list'))
)

const CampaignsDashboard = Loadable(
  lazy(() => import('../features/usecase-config/campaigns-dashboard'))
)

const CampaignsEdit = Loadable(
  lazy(() => import('../features/campaigns/campaigns-edit'))
)

const SchemaList = Loadable(
  lazy(() => import('../features/schema/schema-list'))
)

const SchemaNew = Loadable(lazy(() => import('../features/schema/schema-new')))

const SchemaEdit = Loadable(
  lazy(() => import('../features/schema/schema-edit'))
)
const CustomerNew = Loadable(
  lazy(() => import('../features/customer/customer-new'))
)

const CustomerList = Loadable(
  lazy(() => import('../features/customer/customer-list'))
)

const CustomerEdit = Loadable(
  lazy(() => import('../features/customer/customer-edit'))
)

const ClientConfigNew = Loadable(
  lazy(() => import('../features/client-configuration/client-config-new'))
)

const ClientConfigList = Loadable(
  lazy(() => import('../features/client-configuration/client-config-list'))
)

const ClientConfigEdit = Loadable(
  lazy(() => import('../features/client-configuration/client-config-edit'))
)

const MetadataList = Loadable(
  lazy(() => import('../features/metadata/metadata-list'))
)

const MetadataNew = Loadable(
  lazy(() => import('../features/metadata/metadata-new'))
)

const MetadataEdit = Loadable(
  lazy(() => import('../features/metadata/metadata-edit'))
)

const ClientRequestNew = Loadable(
  lazy(() => import('../features/client-request/client-request-new'))
)


const ClientRequestList = Loadable(
  lazy(() => import('../features/client-request/client-request-list'))
)

// video-library

const LipSynced = Loadable(
  lazy(() => import('../features/library-objects/lip-synced/index'))
)

const TextToSpeach = Loadable(
  lazy(() => import('../features/library-objects/text-to-speech/index'))
)

const Overlay = Loadable(
  lazy(() => import('../features/library-objects/overlay/index'))
)

const TextToSpeachTemplateSpecific = Loadable(
  lazy(() => import('../features/library-objects/text-to-speech-template-specific/index'))
)
const VoiceCloned = Loadable(
  lazy(() => import('../features/library-objects/voice-cloned/index'))
)

const TransliterationService = Loadable(
  lazy(() => import('../features/library-objects/transliteration-service/index'))
)

const StaticKdens = Loadable(lazy(() => import('../features/library-objects/static-kdens/index')))

const FinalVideos = Loadable(lazy(() => import('../features/library-objects/final-videos/index')))

const UsecaseOutput = Loadable(lazy(() => import('../features/library-objects/final-videos/usecase-output/index')))

const VideoStatusDetails = Loadable(
  lazy(() => import('../features/usecase-config/config-create/components/video-status-details/index'))
)
// usecase-config

const UsecaseConfigList = Loadable(
  lazy(() => import('../features/usecase-config/config-list'))
)

// hpi-config
const HpiConfigList = Loadable(
  lazy(() => import('../features/hpi-config/config-list'))
)
const HpiConfigNew = Loadable(
  lazy(() => import('../features/hpi-config/config-new'))
)

const HpiConfigEdit = Loadable(
  lazy(() => import('../features/hpi-config/config-edit'))
)

const HpiCampaignDashboard = Loadable(
  lazy(() => import('../features/hpi-config/campaigns-dashboard'))
)

const HpiOutputs = Loadable(
  lazy(() => import('../features/hpi-config/hpi-outputs'))
)

const BrandNew = Loadable(    
  lazy(() => import('../features/brand/brand-new'))
)

const BrandList = Loadable(    
  lazy(() => import('../features/brand/brand-list'))
)

const BrandEdit = Loadable(
  lazy(() => import('../features/brand/brand-edit'))
)

const TtsPlaygrounnd = Loadable(
  lazy(() => import('../features/ml-playground/tts'))
)

const VcPlaygrounnd = Loadable(
  lazy(() => import('../features/ml-playground/voice-clone'))
)
const LipsyncPlaygrounnd = Loadable(
  lazy(() => import('../features/ml-playground/lip-sync'))
)

const MltPlayground = Loadable(
  lazy(() => import('../features/ml-playground/mlt'))
)

const IterationListing = Loadable(
  lazy(() => import('../features/usecase-config/config-list/iteration-listing/index'))
)

const IterationCountTable = Loadable(
  lazy(() => import('../features/workflow-dag/dag-view/view-count/iterationCountList'))
)

const TestSamplesManagement=Loadable(
  lazy(() => import('../features/library-objects/test-samples'))  
)

const UsecaseConfigNew = Loadable(
  lazy(() => import('../features/usecase-config/config-new'))
)

const UsecaseConfigEdit = Loadable(
  lazy(() => import('../features/usecase-config/config-edit'))
)


const DagList = Loadable(
  lazy(() => import('../features/workflow-dag/dag-list'))
)


const ViewWorkflow = Loadable(
  lazy(() => import('../features/workflow-dag/dag-view'))
)

const FailedCountList = Loadable(
  lazy(() => import('../features/workflow-dag/dag-view/view-count/failedCountList'))
)


const MainRoutes = ({ isLogged, userInfo, ...props }) => {

  return (
    <Routes>
      <Route element={<MainLayout userInfo={userInfo} />}>
        <Route
          path="/"
          element={
            <Protected isLoggedIn={isLogged}>
              <Dashboard />
            </Protected>
          }
        />
        <Route
          path="/dashboard"
          element={
            <Protected isLoggedIn={isLogged}>
              <Dashboard />
            </Protected>
          }
        />
        {/* PUBLIC ASSETS related ROUTES */}
        <Route
          path="/assign/role"
          element={
            <Protected isLoggedIn={isLogged}>
              <RolesPage />
            </Protected>
          }
        />
        <Route
          path="/assets/list"
          element={
            <Protected isLoggedIn={isLogged}>
              <AssetList />
            </Protected>
          }
        />
        <Route
          path="/assets/add"
          element={
            <Protected isLoggedIn={isLogged}>
              <AssetNewPage />
            </Protected>
          }
        />
        <Route
          path="/assets/bulk-add"
          element={
            <Protected isLoggedIn={isLogged}>
              <AssetBulkPage />
            </Protected>
          }
        />
        <Route
          path="/assets/metadata"
          element={
            <Protected isLoggedIn={isLogged}>
              <TagsForm />
            </Protected>
          }
        />
        <Route
          path="/assets/upload"
          element={
            <Protected isLoggedIn={isLogged}>
              <FileUpload />
            </Protected>
          }
        />
        <Route
          path="/assets/edit"
          element={
            <Protected isLoggedIn={isLogged}>
              <AssetInfoEdit />
            </Protected>
          }
        />

        <Route
          path="/assets/edit/:id/draft"
          element={
            <Protected isLoggedIn={isLogged}>
              <AssetEditPage />
            </Protected>
          }
        />
        <Route
          path="/assets/:id/analysing"
          element={
            <Protected isLoggedIn={isLogged}>
              <AnalysingPage />
            </Protected>
          }
        />
        <Route
          path="/assets/view/:id"
          element={
            <Protected isLoggedIn={isLogged}>
              <ViewAssets />
            </Protected>
          }
        />

        {/* IMAGE LIBRARY related ROUTES */}
        <Route
          path="/image/list"
          element={
            <Protected isLoggedIn={isLogged}>
              <ImageList />
            </Protected>
          }
        />

        <Route
          path="/image/:id/edit"
          element={
            <Protected isLoggedIn={isLogged}>
              <ImageEditPage />
            </Protected>
          }
        />

        {/* FONT LIBRARY related ROUTES */}
        <Route
          path="/font/list"
          element={
            <Protected isLoggedIn={isLogged}>
              <FontList />
            </Protected>
          }
        />
        {/* 
        <Route
          path="/assets/edit/create-segment"
          element={
            <Protected isLoggedIn={isLogged}>
              <CreateSegment />
            </Protected>
          }
        />*/}
        <Route
          path="/assets/edit/:id"
          element={
            <Protected isLoggedIn={isLogged}>
              <PublicAssetTabs />
            </Protected>
          }
        />
        <Route
          path="/assets/edit/segment-list"
          element={
            <Protected isLoggedIn={isLogged}>
              <SegmentList />
            </Protected>
          }
        />
        {/* MY ASSETS related ROUTES */}
        <Route
          path="/myassets/list"
          element={
            <Protected isLoggedIn={isLogged}>
              <MyAssetList />
            </Protected>
          }
        />
        <Route
          path="/myassets/add"
          element={
            <Protected isLoggedIn={isLogged}>
              <MyAssetPage />
            </Protected>
          }
        />
        <Route
          path="/myassets/bulk-add"
          element={
            <Protected isLoggedIn={isLogged}>
              <MyAssetBulkPage />
            </Protected>
          }
        />
        <Route
          path="/myassets/edit"
          element={
            <Protected isLoggedIn={isLogged}>
              <MyAssetInfoEdit />
            </Protected>
          }
        />
        <Route
          path="/myassets/metadata"
          element={
            <Protected isLoggedIn={isLogged}>
              <TagsForm />
            </Protected>
          }
        />
        <Route
          path="/myassets/upload"
          element={
            <Protected isLoggedIn={isLogged}>
              <FileUpload />
            </Protected>
          }
        />
        <Route
          path="/myassets/edit/:id/draft"
          element={
            <Protected isLoggedIn={isLogged}>
              <MyAssetEditPage />
            </Protected>
          }
        />
        <Route
          path="/myassets/:id/analysing"
          element={
            <Protected isLoggedIn={isLogged}>
              <MyAssetAnalysingPage />
            </Protected>
          }
        />
        <Route
          path="/myassets/edit/:id"
          element={
            <Protected isLoggedIn={isLogged}>
              <MyAssetInReviewPage />
            </Protected>
          }
        />


        {/* UPCOMING EVENTS related ROUTES */}
        <Route
          path="/upcoming/events"
          element={
            <Protected isLoggedIn={isLogged}>
              <EventsPage />
            </Protected>
          }
        />

        {/* TRENDING TOPICS related ROUTES */}
        <Route
          path="/trending/topics"
          element={
            <Protected isLoggedIn={isLogged}>
              <TrendingTopicsPage />
            </Protected>
          }
        />

        {/* COPYRIGHT CONTENT related ROUTES */}
        <Route
          path="/copyright-content/list"
          element={
            <Protected isLoggedIn={isLogged}>
              <ContentList />
            </Protected>
          }
        />
        <Route
          path="/copyright-content/add"
          element={
            <Protected isLoggedIn={isLogged}>
              <ContentCreatePage />
            </Protected>
          }
        />

        <Route
          path="/copyright-content/edit"
          element={
            <Protected isLoggedIn={isLogged}>
              <ContentEditPage />
            </Protected>
          }
        />
        {/* CATEGORY and SUB-CATEGORY related ROUTES */}
        <Route
          path="/category/list"
          element={
            <Protected isLoggedIn={isLogged}>
              <CategoryList />
            </Protected>
          }
        />
        <Route
          path="/subcategory/list"
          element={
            <Protected isLoggedIn={isLogged}>
              <SubCategoryList />
            </Protected>
          }
        />
        <Route
          path="/subcategory/list"
          element={
            <Protected isLoggedIn={isLogged}>
              <Subcategory />
            </Protected>
          }
        />
        {/* VENDOR related ROUTES */}
        <Route
          path="/vendor/list"
          element={
            <Protected isLoggedIn={isLogged}>
              <VendorList />
            </Protected>
          }
        />

        {/* TEMPLATE related ROUTES */}
        <Route
          path="/templates/list"
          element={
            <Protected isLoggedIn={isLogged}>
              <TemplateList />
            </Protected>
          }
        />
        <Route
          path="/templates/add"
          element={
            <Protected isLoggedIn={isLogged}>
              <TemplateNew />
            </Protected>
          }
        />

        <Route
          path="/templates/edit/:id/draft"
          element={
            <Protected isLoggedIn={isLogged}>
              <DraftTemplatePage />
            </Protected>
          }
        />
        <Route
          path="/templates/add-source"
          element={
            <Protected isLoggedIn={isLogged}>
              <TemplateNewSource />
            </Protected>
          }
        />
        <Route
          path="/templates/add-orientation"
          element={
            <Protected isLoggedIn={isLogged}>
              <TemplateNewOrientation />
            </Protected>
          }
        />
        <Route
          path="/templates/events"
          element={
            <Protected isLoggedIn={isLogged}>
              <UpcomingTemplateList />
            </Protected>
          }
        />


        <Route
          path="/template/:id/edit"
          element={
            <Protected isLoggedIn={isLogged}>
              <UpcomingTemplateEdit />
            </Protected>
          }
        />

        <Route
          path="/template/:id/instance/list"
          element={
            <Protected isLoggedIn={isLogged}>
              <TemplateInstances />
            </Protected>
          }
        />

        <Route
          path="/template/:id/instance/add"
          element={
            <Protected isLoggedIn={isLogged}>
              <TemplateInstanceAdd />
            </Protected>
          }
        />

        <Route
          path="/templates/edit"
          element={
            <Protected isLoggedIn={isLogged}>
              <TemplateInfoEdit />
            </Protected>
          }
        />

        {/* Tags related ROUTES */}
        <Route
          path="/entity-tags/list"
          element={
            <Protected isLoggedIn={isLogged}>
              <EntityList />
            </Protected>
          }
        />

        <Route
          path="/entity-tags/add"
          element={
            <Protected isLoggedIn={isLogged}>
              <EntityTagsNew />
            </Protected>
          }
        />
        <Route
          path="/entity-tags/:id/edit"
          element={
            <Protected isLoggedIn={isLogged}>
              <EntityTagsEdit />
            </Protected>
          }
        />

        {/*Identifier related ROUTES */}

        <Route
          path="/identifier/list"
          element={
            <Protected isLoggedIn={isLogged}>
              <IdentifierList />
            </Protected>
          }
        />

        <Route
          path="/identifier/add"
          element={
            <Protected isLoggedIn={isLogged}>
              <IdentifierNew />
            </Protected>
          }
        />

        <Route
          path="/identifier/:id/edit"
          element={
            <Protected isLoggedIn={isLogged}>
              <IdentifierEdit />
            </Protected>
          }
        />

        {/*Compostion tags related ROUTES */}

        <Route
          path="/composition-tags/list"
          element={
            <Protected isLoggedIn={isLogged}>
              <CompositionTagsList />
            </Protected>
          }
        />

        <Route
          path="/composition-tags/add"
          element={
            <Protected isLoggedIn={isLogged}>
              <CompositionTagsNew />
            </Protected>
          }
        />

        <Route
          path="/composition-tags/:id/edit"
          element={
            <Protected isLoggedIn={isLogged}>
              <CompositionTagsEdit />
            </Protected>
          }
        />

        <Route
          path="/schema/list"
          element={
            <Protected isLoggedIn={isLogged}>
              <SchemaList />
            </Protected>
          }
        />

        <Route
          path="/schema/add"
          element={
            <Protected isLoggedIn={isLogged}>
              <SchemaNew />
            </Protected>
          }
        />

        <Route
          path="/schema/:id/edit"
          element={
            <Protected isLoggedIn={isLogged}>
              <SchemaEdit />
            </Protected>
          }
        />

        <Route
          path="/customer"
          element={
            <Protected isLoggedIn={isLogged}>
              <CustomerList />
            </Protected>
          }
        />

        <Route
          path="/customer/add"
          element={
            <Protected isLoggedIn={isLogged}>
              <CustomerNew />
            </Protected>
          }
        />

        <Route
          path="/customer/:id/edit"
          element={
            <Protected isLoggedIn={isLogged}>
              <CustomerEdit />
            </Protected>
          }
        />

        <Route
          path="/client-configuration"
          element={
            <Protected isLoggedIn={isLogged}>
              <ClientConfigList />
            </Protected>
          }
        />

        <Route
          path="/client-configuration/add"
          element={
            <Protected isLoggedIn={isLogged}>
              <ClientConfigNew />
            </Protected>
          }
        />

        <Route
          path="/client-configuration/:id/edit"
          element={
            <Protected isLoggedIn={isLogged}>
              <ClientConfigEdit />
            </Protected>
          }
        />

        <Route
          path="/metadata/list"
          element={
            <Protected isLoggedIn={isLogged}>
              <MetadataList />
            </Protected>
          }
        />

        <Route
          path="/metadata/add"
          element={
            <Protected isLoggedIn={isLogged}>
              <MetadataNew />
            </Protected>
          }
        />

        <Route
          path="/metadata/:id/edit"
          element={
            <Protected isLoggedIn={isLogged}>
              <MetadataEdit />
            </Protected>
          }
        />

        <Route
          path="/client/add"
          element={
            <Protected isLoggedIn={isLogged}>
              <ClientRequestNew />
            </Protected>
          }
        />


        <Route
          path="/client/list"
          element={
            <Protected isLoggedIn={isLogged}>
              <ClientRequestList />
            </Protected>
          }
        />

        {/*Campaigns related ROUTES - HPV */}

        <Route
          path="/campaigns/add"
          element={
            <Protected isLoggedIn={isLogged}>
              <CampaignsNew />
            </Protected>
          }
        />

        <Route
          path="/campaigns/list"
          element={
            <Protected isLoggedIn={isLogged}>
              <CampaignsList />
            </Protected>
          }
        />

        <Route
          path="/campaigns/:id/edit"
          element={
            <Protected isLoggedIn={isLogged}>
              <CampaignsEdit />
            </Protected>
          }
        />

        {/*Campaigns related ROUTES - HPI */}

        <Route
          path="/hpi/campaigns/add"
          element={
            <Protected isLoggedIn={isLogged}>
              <CampaignsNew />
            </Protected>
          }
        />

        <Route
          path="/hpi/campaigns/list"
          element={
            <Protected isLoggedIn={isLogged}>
              <CampaignsList />
            </Protected>
          }
        />

        <Route
          path="/hpi/campaigns/:id/edit"
          element={
            <Protected isLoggedIn={isLogged}>
              <CampaignsEdit />
            </Protected>
          }
        />

        <Route
          path="/hpi/campaigns/:id/test-samples"
          element={
            <Protected isLoggedIn={isLogged}>
              <TestSamplesManagement />
            </Protected>
          }
        />

        {/* OTHER ROUTES */}
        <Route
          path="/clip/upload"
          element={
            <Protected isLoggedIn={isLogged}>
              <ClipMetaData />
            </Protected>
          }
        />
        <Route
          path="/upload/videoclip"
          element={
            <Protected isLoggedIn={isLogged}>
              <UploadVideoClip />
            </Protected>
          }
        />

        <Route
          path="/library/transliteration"
          element={
            <Protected isLoggedIn={isLogged}>
              <TransliterationService />
            </Protected>
          }
        />

        <Route
          path="/library/global/tts"
          element={
            <Protected isLoggedIn={isLogged}>
              <TextToSpeach />
            </Protected>
          }
        />

        <Route
          path="/library/template/overlay"
          element={
            <Protected isLoggedIn={isLogged}>
              <Overlay />
            </Protected>
          }
        />

        <Route
          path="/library/template/tts"
          element={
            <Protected isLoggedIn={isLogged}>
              <TextToSpeachTemplateSpecific />
            </Protected>
          }
        />

        <Route
          path="/library/ls"
          element={
            <Protected isLoggedIn={isLogged}>
              <LipSynced />
            </Protected>
          }
        />



        <Route
          path="/library/vc"
          element={
            <Protected isLoggedIn={isLogged}>
              <VoiceCloned />
            </Protected>
          }
        />

        <Route
          path="/library/kden"
          element={
            <Protected isLoggedIn={isLogged}>
              <StaticKdens />
            </Protected>
          }
        />


        <Route
          path="/library/output/:id/:slug"
          element={
            <Protected isLoggedIn={isLogged}>
              <FinalVideos />
            </Protected>
          }
        />

       <Route
          path="/campaigns/:id/test-samples"
          element={
            <Protected isLoggedIn={isLogged}>
              <TestSamplesManagement />
            </Protected>
          }
        /> 

        {/* Usecase/Campaign routes - HPV */}
        <Route
          path="/usecase"
          element={
            <Protected isLoggedIn={isLogged}>
              <UsecaseConfigList />
            </Protected>
          }
        />

        <Route
          path="/usecase/:id"
          element={
            <Protected isLoggedIn={isLogged}>
              <IterationListing />
            </Protected>
          }
        />

         <Route
          path="/usecase/:id/:slug/dashboard"
          element={
            <Protected isLoggedIn={isLogged}>
             <CampaignsDashboard/>
            </Protected>
          }
        />

        <Route
          path="/usecase/:id/:id"
          element={
            <Protected isLoggedIn={isLogged}>
              <IterationCountTable />
            </Protected>
          }
        />

        <Route
          path="/usecase/add"
          element={
            <Protected isLoggedIn={isLogged}>
              <UsecaseConfigNew />
            </Protected>
          }
        />

        {/* Usecase/Campaign routes - HPI */}
        <Route
          path="/hpi/usecase"
          element={
            <Protected isLoggedIn={isLogged}>
              <HpiConfigList />
            </Protected>
          }
        />

        <Route
          path="/hpi/usecase/:id"
          element={
            <Protected isLoggedIn={isLogged}>
              <IterationListing />
            </Protected>
          }
        />

        <Route
          path="/hpi/usecase/:id/:slug/dashboard"
          element={
            <Protected isLoggedIn={isLogged}>
              <HpiCampaignDashboard />
            </Protected>
          }
        />
        <Route
          path="/hpi/outputs/:id/:slug"
          element={
            <Protected isLoggedIn={isLogged}>
              <HpiOutputs />
            </Protected>
          }
        />

        <Route
          path="/hpi/usecase/:id/:id"
          element={
            <Protected isLoggedIn={isLogged}>
              <IterationCountTable />
            </Protected>
          }
        />

        <Route
          path="/hpi/usecase/add"
          element={
            <Protected isLoggedIn={isLogged}>
              <HpiConfigNew />
            </Protected>
          }
        />

        <Route
          path="/hpi/usecase/:id/edit"
          element={
            <Protected isLoggedIn={isLogged}>
              <HpiConfigEdit />
            </Protected>
          }
        />


        <Route
          path="/library/output/:id/:id"
          element={
            <Protected isLoggedIn={isLogged}>
              <VideoStatusDetails />
            </Protected>
          }
        />


        <Route
          path="/cache/:id/failed-details"
          element={
            <Protected isLoggedIn={isLogged}>
              <FailedCountList />
            </Protected>
          }
        />

        <Route
          path="/usecase/:id/edit"
          element={
            <Protected isLoggedIn={isLogged}>
              <UsecaseConfigEdit />
            </Protected>
          }
        />


        <Route
          path="/brand/list"
          element={
            <Protected isLoggedIn={isLogged}>
              <BrandList />
            </Protected>
          }
        />

        <Route
          path="/brand/:id/edit"
          element={
            <Protected isLoggedIn={isLogged}>
              <BrandEdit />
            </Protected>
          }
        />


        <Route
          path="/brand/add"
          element={
            <Protected isLoggedIn={isLogged}>
              <BrandNew />
            </Protected>
          }
        />

        <Route
          path="/tts-playground"
          element={
            <Protected isLoggedIn={isLogged}>
              <TtsPlaygrounnd />
            </Protected>
          }
        />

        <Route
          path="/vc-playground"
          element={
            <Protected isLoggedIn={isLogged}>
              <VcPlaygrounnd />
            </Protected>
          }
        />

        <Route
          path="/ls-playground"
          element={
            <Protected isLoggedIn={isLogged}>
              <LipsyncPlaygrounnd />
            </Protected>
          }
        />

        <Route
          path="/mlt-playground"
          element={
            <Protected isLoggedIn={isLogged}>
              <MltPlayground />
            </Protected>
          }
        />

        <Route
          path="/dag/list"
          element={
            <Protected isLoggedIn={isLogged}>
              <DagList />
            </Protected>
          }
        />


        <Route
          path="/dag/view/:workflowname"
          element={
            <Protected isLoggedIn={isLogged}>
              <ViewWorkflow />
            </Protected>
          }
        />

      </Route>

      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

const mapStateToProps = () => ({})
const mapActionsToProps = {
  EnumDataAction,
}

export default connect(mapStateToProps, mapActionsToProps)(MainRoutes)
